import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@digital-services/ui";

import { OrganizationStatus } from "@organization/models/OrganizationDetails";
import { useGetOrganizationDetails } from "@organization/services/use-organization";

import { useDrawerWithConfirm } from "@hooks/useDrawerWithConfirm";
import { useUserContext } from "@hooks/useUserContext";
import InviteUserIcon from "@icons/invite_user.svg?react";

import { EditApplicationUser } from "./EditApplicationUser";

const InviteApplicationUserButton: FunctionComponent = () => {
  const { user } = useUserContext();
  const { organization, isLoading } = useGetOrganizationDetails();
  const { t } = useTranslation(undefined, { keyPrefix: "application.users" });

  const { showDrawer, hideDrawer } = useDrawerWithConfirm();

  const editApplicationUser = () => {
    showDrawer({
      title: t("invite.title"),
      children: (
        <EditApplicationUser
          onSuccess={() => {
            hideDrawer();
          }}
          onCancel={hideDrawer}
        />
      )
    });
  };

  if (!user.isAdministrator) return "";

  const orgInactive = organization?.status === OrganizationStatus.Inactive;

  return (
    <div data-testid="invite-application-user-button-container">
      <Button
        isLoading={isLoading}
        disabled={orgInactive}
        icon={<InviteUserIcon />}
        variant="primary"
        className="min-w-max"
        onClick={editApplicationUser}
        data-testid="invite-application-user-button"
      >
        {t("invite.label")}
      </Button>
    </div>
  );
};

export default InviteApplicationUserButton;
